import { Skeleton, Stack } from '@chakra-ui/react';

export const LoadingSkeleton: React.FC<{ count?: number; h?: string; gap?: string }> = ({
  count = 1,
  h = '148px',
  gap = '12px'
}) => (
  <Stack w="100%" h="100%" gap={gap}>
    {Array.from({ length: count }, (_, index) => (
      <Skeleton
        key={index}
        w="100%"
        h={h}
        border="1px solid"
        borderColor="neutrals.200"
        borderRadius="12px"
      />
    ))}
  </Stack>
);
